/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class StatusAndStateService extends services.DataService<Wars.Domain.Model.Statuses.StatusCodeGroup> {
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public createNewSystemStatusCodeGroup(): Wars.Domain.Model.Statuses.StatusCodeGroup {
            var newStatusCodeGroup = this.createNewEntity<Wars.Domain.Model.Statuses.StatusCodeGroup>("StatusCodeGroup");
            return newStatusCodeGroup;
        }

        public createNewStatus(): Wars.Domain.Model.Statuses.StatusCode {
            var newStatus = this.createNewEntity<Wars.Domain.Model.Statuses.StatusCode>("StatusCode");
            newStatus.uniqueIdentifier = UtilityService.generateGuidComb();
            newStatus.isInitialStatus = false;
            newStatus.isSystemLevel = true;
            return newStatus;
        }

        createNewState(): Wars.Domain.Model.Statuses.StateCode {
            var newState = this.createNewEntity<Wars.Domain.Model.Statuses.StateCode>("StateCode");
            newState.uniqueIdentifier = UtilityService.generateGuidComb();
            newState.isInitialState = false;
            newState.isSystemLevel = true;
            return newState;
        }

        public getStatusAndStatesByProcessConfig(processConfigId: string):ng.IPromise<Wars.Domain.Model.Statuses.StatusCodeGroup> {
            const query = this.breezeModule.EntityQuery
                .from("StatusCodeGroups")
                .where("processConfiguration_id", "==", processConfigId)
                .expand("myStatuses.myStates");

            return (this.fetch(query)) as any;
        }

        public getStatusCodeGroup(id: string): ng.IPromise<Wars.Domain.Model.Statuses.StatusCodeGroup> {
            const query = this.breezeModule.EntityQuery
                .from("StatusCodeGroups")
                .where("id", "==", id)
                .expand("myStatuses.myStates");

            return this.fetch(query);
        }
    }
}

warsApp.registerService('StatusAndStateService', ['breeze', '$q'])